__turbopack_context__.v({
  "Rightcontent": "JobEligibilitySection-module-scss-module__u1OAqG__Rightcontent",
  "buttonWrapper": "JobEligibilitySection-module-scss-module__u1OAqG__buttonWrapper",
  "checkBtn": "JobEligibilitySection-module-scss-module__u1OAqG__checkBtn",
  "checkIcon": "JobEligibilitySection-module-scss-module__u1OAqG__checkIcon",
  "contentContainer": "JobEligibilitySection-module-scss-module__u1OAqG__contentContainer",
  "contentDiv": "JobEligibilitySection-module-scss-module__u1OAqG__contentDiv",
  "headingContainer": "JobEligibilitySection-module-scss-module__u1OAqG__headingContainer",
  "imageContainer": "JobEligibilitySection-module-scss-module__u1OAqG__imageContainer",
  "mainContainer": "JobEligibilitySection-module-scss-module__u1OAqG__mainContainer",
  "note": "JobEligibilitySection-module-scss-module__u1OAqG__note",
  "textContent": "JobEligibilitySection-module-scss-module__u1OAqG__textContent",
});
